import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import LoadingBtn from '../loadingBtn/view';
import { lang } from '../../../utils/langs';
import './style.css';

function ButtonPrimary({
    id,
    icon,
    title,
    type = 'button',
    className = '',
    style = {},
    disabled = false,
    hidden = false,
    onClick,
    loadingColor = 'white',
    showLoading = false,
    modalID,
    children,
    badge: badgeProp = 0
}) {
    const [loading, setLoading] = useState(false);
    const [badge, setBadge] = useState(badgeProp);

    useEffect(() => {
        const handleEvent = () => setLoading(false);
        window.addEventListener('loading-btn', handleEvent);
        window.addEventListener(id ? `loading-btn-${id}` : 'loading-btn', handleEvent);
        return () => {
            window.removeEventListener('loading-btn', handleEvent);
            window.removeEventListener(id ? `loading-btn-${id}` : 'loading-btn', handleEvent);
        };
    }, [id]);

    useEffect(() => {
        setBadge(badgeProp);
    }, [badgeProp]);

    const handleClick = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        if (showLoading) {
            setLoading(true);
        }
        if (modalID) {
            dispatchCustomEvent(`modal${modalID}`, { eventKey: id });
        }
        if (onClick) onClick(e);
    };

    return (
        <button
            id={id || 'btn-primary'}
            style={style}
            disabled={disabled || loading}
            hidden={hidden}
            type={type}
            className={`btn-primary-filled ${className}`}
            onClick={handleClick}
        >
            <LoadingBtn loading={loading && showLoading} color={loadingColor}>
                {children}
                {icon}
                {title ? lang('es', title) : null}
                {badge > 0 && (
                    <Badge style={{ marginLeft: '10px' }} bg="danger">
                        {badge}
                    </Badge>
                )}
            </LoadingBtn>
        </button>
    );
}

export default ButtonPrimary;
